import { deleteCookie, getCookie } from 'helpers';
import config from 'config';
import { Debt } from 'features/matriculates/matriculatesAPI';
import { APIResponse } from 'types/Request';

function revokeCredentials() {
  deleteCookie('accessToken');
  deleteCookie('sessionCookie');
  // eslint-disable-next-line no-restricted-globals
  return location.reload();
}

export interface GetPreferenceIdMatriculacionBody {
  solocitud_id: number,
  description: string,
}

export interface GetPreferenceIdRematriculacionBody {
  id: number,
  description: string,
}

export interface PreferenceIdResponse {
  status: string,
  payload?: string,
}

export async function getMatriculacionPreferenceId(
  body: Partial<GetPreferenceIdMatriculacionBody>): Promise<PreferenceIdResponse | undefined> {
  try {
    const url = new URL(`${ config.baseUrl }/mercadopago/matriculacion/create`);

    const res = await fetch(url.toString(), {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
      body: JSON.stringify(body),
    });

    if (res.status === 400) return;

    if (res.status === 401 && true) {
      revokeCredentials();
    }

    return res.json();
  } catch (error) {
    console.error('Request get preferenceId api fail', error);
    return error;
  }
}

export async function getRematriculacionPreferenceId(
  body: Partial<GetPreferenceIdRematriculacionBody>): Promise<PreferenceIdResponse | undefined> {
  try {
    const url = new URL(`${ config.baseUrl }/mercadopago/rematriculacion/create`);

    const res = await fetch(url.toString(), {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
      body: JSON.stringify(body),
    });

    if (res.status === 400) return;

    if (res.status === 401 && true) {
      revokeCredentials();
    }

    return res.json();
  } catch (error) {
    console.error('Request get preferenceId api fail', error);
    return error;
  }
}

export async function getCuotasPreferenceId(matriculado: number, cuotas: Debt[]): Promise<string | undefined> {
  try {
    const url = new URL(`${ config.baseUrl }/mercadopago/ctacte/create`);

    const periodos = cuotas
      .map(c => c.concepto)
      .toString()
      .replace(/\//g, '-')
      .replace(/,/g, ' ');

    const total = cuotas
      .map(c => c.monto + c.recargo)
      .reduce((acc, val) => acc + val, 0)
      .toFixed(2);

    const body = {
      matriculate_id: matriculado,
      description: periodos,
      amount: total,
    };

    const response = await fetch(url.toString(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
      body: JSON.stringify(body),
    });

    if (response.status === 400) return;

    if (response.status === 401 && true) {
      revokeCredentials();
    }

    type Response = APIResponse<string>;

    const content = await response.json() as Response;
    const { payload } = content;

    return payload;
  } catch (error) {
    console.error('Request get preferenceId api fail', error);
    return error;
  }
}
